import { render } from "./AddEmailOrPhone.vue?vue&type=template&id=56ae6bde&scoped=true"
import script from "./AddEmailOrPhone.vue?vue&type=script&lang=js"
export * from "./AddEmailOrPhone.vue?vue&type=script&lang=js"

import "./AddEmailOrPhone.vue?vue&type=style&index=0&id=56ae6bde&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ae6bde"]])

export default __exports__